import { initials } from '@/lib/format'
import { cn } from '@/lib/cn'

const SIZES = { sm: 'size-5 text-2xs', md: 'size-7 text-xs', lg: 'size-10 text-sm' }

/**
 * Deterministic tint from the name so the same person is always the same colour —
 * an incidental but genuinely useful scanning aid in long tables.
 */
const TINTS = [
  'bg-info-subtle text-info',
  'bg-success-subtle text-success',
  'bg-warning-subtle text-warning',
  'bg-violet-subtle text-violet',
  'bg-neutral-subtle text-fg-muted',
]

function tintFor(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0
  return TINTS[hash % TINTS.length]!
}

export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name: string | null | undefined
  size?: keyof typeof SIZES
  className?: string
}) {
  const label = name ?? 'Unknown'
  return (
    <span
      // The adjacent name is the accessible label; this is decoration.
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-medium',
        SIZES[size],
        tintFor(label),
        className,
      )}
    >
      {initials(label)}
    </span>
  )
}
